import { duration } from '../utils/duration';

type DaycareOptions = typeof daycareOptions;
export type DaycareId = keyof DaycareOptions;
export type DaycareOption = DaycareOptions[DaycareId];

export const daycareUnlockLevel = 3;

export const daycareOptions = {
  d_daycare_6h: {
    price: 3_000,
    duration: duration({ hours: 6 }),
    duration_en: '6 hours',
    duration_jp: '6時間',
    name_en: '6-Hour Pack',
    name_jp: '6時間おあずけ',
    desc_en: "Pet status doesn't change for 6 hours",
    desc_jp: 'あずけている間、ぶるぶるの\n状態は変わらないよ',
  },
};
